import { QueryColumn } from "core-components/wp-query/query-column";

export const internalSortColumn = {
  id: '__internal-sorthandle'
} as QueryColumn;

export const internalContextMenuColumn = {
  id: '__internal-contextMenu'
} as QueryColumn;

